export default __webpack_public_path__ + "static/media/NMC_18.2a52e8fe.svg";